import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { consumerTheme } from 'syf-component-library/defaultTheme';
import { I18nextProvider } from 'react-i18next';
import { ConfigProvider } from '../hooks/use-config';
import i18n from '../strings/i18n';
import '../const/initiate-icon-library';
export const DefaultProviders = ({ config, children }) => {
    return (_jsx(ConfigProvider, { value: config, children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(ThemeProvider, { theme: consumerTheme, children: children }) }) }));
};
export default DefaultProviders;
